import {
  AgeGrade,
  Maybe,
  SimpleSeriesSingleInfo,
} from '../../graphql/generated/types';
import {UserState} from '../../user/UserState.interface';
import {AGE_GRADE_TO_NUMBER_MAP} from '../constant';
import {getShouldSelfCertToAccessContent} from '../getShouldSelfCertToAccessContent';

export function isSimpleSeriesSingleAgeRestricted(
  seriesSingleInfo: Maybe<SimpleSeriesSingleInfo>,
  user: Maybe<UserState['user']>
): boolean {
  const userAge = user?.age;
  const singleAgeGrade =
    seriesSingleInfo?.singleAgeGrade || seriesSingleInfo?.seriesAgeGrade;

  if (!singleAgeGrade) {
    return false;
  }

  const singleAgeGradeNum = AGE_GRADE_TO_NUMBER_MAP[singleAgeGrade];
  const userAgeNum = Number(userAge || '0');
  return (
    (singleAgeGradeNum >= AGE_GRADE_TO_NUMBER_MAP[AgeGrade.Nineteen] &&
      userAgeNum < singleAgeGradeNum) ||
    getShouldSelfCertToAccessContent({
      ageGrade: singleAgeGrade,
      userAge,
      userAuthenticatedAt: user?.authenticatedAt,
    })
  );
}
